export const pages = new Map([
    ["25", "25"],
    ["50", "50"],
    ["75", "75"],
    ["100", "100"],
    ["200", "200"],
  ]);
  
  export const pageList = Array.from(pages.keys());
  